import {Injectable, Signal} from '@angular/core';
import {SignalEntityQuery} from '../../state/signal-entity.store';
import {ShoppingCartState, ShoppingCartStore} from './shopping-cart-store';
import {ShoppingCartItem} from '../../models/underwriter.model';

@Injectable({
    providedIn: 'root'
})
export class ShoppingCartQuery extends SignalEntityQuery<ShoppingCartItem, ShoppingCartState>{
    /** Reactive read access — preferred for new code. */
    readonly items: Signal<ShoppingCartItem[]> = this.store.entitiesList;
    readonly active: Signal<ShoppingCartItem | undefined> = this.store.activeEntity;

    constructor(protected store: ShoppingCartStore) {
        super(store);
    }

    getCartItemByClassItemId(class_id: number, item_id: string){
        return this.selectAll({
            filterBy: [
                entity => entity.item_id === item_id && entity.class_id === class_id
            ]
        });
    }
}
